<template>
<v-dialog v-model="dialog" width="500px">
  <v-card>
    <v-card-title class="warning headline" style="font-weight:bold; color:white">Confirm Delete</v-card-title>
    <v-card-text>Are you sure you want to remove {{hctr.fctitaal_oms}} {{hctr.hctr_bedrag}} from the accommodation {{hctr.huov_code}} ?</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="warning mx-2" small @click="rmHctr">Yes</v-btn>
      <v-btn color="success"  small @click="dialog = false">No</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      hctr_encrid: null,
      hctr: {}
    }
  },
  methods: {
    open(hctr_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/hctr/getHctr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHctr"
          },
          getHctr: {
            hctr_encrid: hctr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hctr = res.data.getHctr;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rmHctr() { 
      this.$axios
        .post("ares/json/ares/huov/hctr/rmHctr.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmHctr"
          },
          rmHctr: {
            hctr_encrid: this.hctr.hctr_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huov/onHuov/' + res.data.rmHctr.huov_encrid); 
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rmHctr.text,
              color: res.data.rmHctr.color
            });
            
            this.dialog = false;
          }
        })
    },
  }
}
</script>

